// webapp/src/lib/ipscResultsView.js — pure view helpers for the IPSC result
// list (results page, TV board). Formatting + flattening only; the math is in
// ipscScoring.js.

import { DIVISIONS } from './ipsc';
import { stageMaxPoints } from './ipscScoring';

const MAX_SQUADS = 100;

export function divisionTabs(matchResults = {}) {
    const divisions = matchResults.divisions || {};
    return DIVISIONS
        .filter(d => divisions[d.key] && (divisions[d.key].shooters || []).length > 0)
        .map(d => ({ key: d.key, label: d.label, count: divisions[d.key].shooters.length }));
}

export function stageColumns(stageDefs = {}) {
    return Object.keys(stageDefs)
        .map(Number)
        .sort((a, b) => a - b)
        .map(stand => ({ stand, max: stageMaxPoints(stageDefs[stand]) }));
}

export function formatHf(n) {
    return n === null || n === undefined || !Number.isFinite(Number(n)) ? '–' : Number(n).toFixed(4);
}

export function formatPercent(n) {
    return `${(Number(n) || 0).toFixed(2)} %`;
}

export function formatPoints(n) {
    return (Number(n) || 0).toFixed(2);
}

// Flatten participants1..N (squad entries) — the input buildMatchResults expects.
export function squadEntriesOf(convention = {}) {
    const out = [];
    for (let i = 1; i <= MAX_SQUADS; i += 1) {
        const list = convention[`participants${i}`];
        if (Array.isArray(list)) {
            list.forEach((p) => { if (p && p.id) out.push(p); });
        }
    }
    return out;
}
